import { render, staticRenderFns } from "./document-template-editor.vue?vue&type=template&id=5e646e6f&scoped=true&"
import script from "./document-template-editor.ts?vue&type=script&lang=ts&"
export * from "./document-template-editor.ts?vue&type=script&lang=ts&"
import style0 from "./document-template-editor.scss?vue&type=style&index=0&id=5e646e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e646e6f",
  null
  
)

export default component.exports